import { transitionDurations } from "../../theme";

export const contentMotionVariants = {
  visible: {
    opacity: 1,
    transition: {
      duration: transitionDurations.xs,
      ease: "linear" as const,
      staggerChildren: 0.05,
      when: "beforeChildren" as const,
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      duration: transitionDurations.s,
      delay: 0,
      ease: "easeInOut" as const,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: transitionDurations.s,
      delay: 0,
      ease: "easeInOut" as const,
    },
  },
};

export const contentChildMotionVariants = {
  hidden: {
    opacity: 0,
    x: 10,
    transition: {
      duration: transitionDurations.xs,
      ease: "easeInOut" as const,
    },
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: transitionDurations.xs,
      ease: "easeInOut" as const,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: transitionDurations.xs,
      ease: "easeInOut" as const,
    },
  },
};
